import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header'; // Header bileşenini içe aktar
import TabBar from '../components/TabBar';
import '../styles/TrafikHaritasi.css';
import { Container } from 'react-bootstrap';

declare global {
  interface Window {
    google: any;
    initMap: () => void;
  }
}

const TrafikHaritasi: React.FC = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Google Maps API'sini yükle
    const loadGoogleMapsAPI = () => {
      const script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyASHeUqGfcIe2_QixdvcCjbiSVFgkQSAhQ&callback=initMap';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
      
      return () => {
        document.head.removeChild(script);
      };
    };
    
    // Haritayı başlat
    window.initMap = () => {
      // İstanbul koordinatları
      const istanbul = {
        lat: 41.0082,
        lng: 28.9784
      };

      // Harita oluşturma
      const map = new window.google.maps.Map(document.getElementById("map"), {
        zoom: 10,
        center: istanbul,
        mapTypeControl: true,
        streetViewControl: true,
        fullscreenControl: true,
        zoomControl: true,
      });

      // Trafik katmanı ekleme
      const trafficLayer = new window.google.maps.TrafficLayer();
      trafficLayer.setMap(map);
    };
    
    const cleanup = loadGoogleMapsAPI();
    
    return () => {
      cleanup();
      window.initMap = () => {};
    };
  }, []);
  
  // Geri dön
  const handleBack = () => {
    navigate(-1);
  };
  
  return (
    <div className="trafikharitasi-container" style={{ paddingTop: 70 }}>
      <Header title="Trafik Haritası" />
      <Container className="py-4">
        <main className="trafik-main">
          <div className="map-container">
            <div id="map"></div>
          </div>
          
          <div className="map-info">
            <div className="info-card">
              <h3><i className="fas fa-info-circle"></i> Trafik Bilgisi</h3>
              <p>Harita üzerinde İstanbul'un güncel trafik durumunu görebilirsiniz. Renkler trafik yoğunluğunu gösterir:</p>
              <ul className="traffic-legend">
                <li><span className="color-box green"></span> Açık Trafik</li>
                <li><span className="color-box orange"></span> Orta Yoğunlukta Trafik</li>
                <li><span className="color-box red"></span> Yoğun Trafik</li>
                <li><span className="color-box dark-red"></span> Çok Yoğun Trafik</li>
              </ul>
            </div>
          </div>
        </main>
        
        <footer className="trafik-footer">
          <p>Veriler Google Maps tarafından sağlanmaktadır. Gerçek zamanlı trafik bilgisi için resmi kaynakları kontrol ediniz.</p>
        </footer>
      </Container>
      
      {/* Tab Bar Bileşeni */}
      <TabBar />
    </div>
  );
};

export default TrafikHaritasi; 